<template>
  <div class="informedConsent">
    <van-nav-bar
      :title="title"
      left-arrow
      class="main-nav"
      @click-left="onClickLeft"
    />
    <div
      class="consentList"
      v-loading="loading"
      element-loading-text="数据加载中..."
    >
      <div v-for="item in informedList" :key="item.id">
        <p v-html="item.content"></p>
      </div>
      <!-- <img :src="signImg" class="signImg" alt=""> -->
    </div>
  </div>
</template>

<script>
import { _contentPage, _contentId } from "../../api/setting";
import { verticalScreen } from "../../assets/js/vertical-screen";
export default {
  name: "informed-consent-detail",
  data() {
    return {
      title: "知情同意书",
      loading: true,
      message: "",
      signImg: "",
      id: "",
      informedList: [],
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.title = this.$route.query.title + this.$route.query.version;
    this.signImg = this.$route.query.signImg;
    this.contentId();
  },
  mounted() {
    verticalScreen();
  },
  methods: {
    // 返回
    onClickLeft() {
      this.$router.go(-1);
    },
    contentId() {
      _contentId(this.id).then((res) => {
        this.loading = false;
        if (res && res.code == 200) {
          this.informedList = res.data;
        } else {
          this.$toast(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.main-nav {
  position: fixed;
  width: 100%;
  top: 0;
}
.consentList {
  padding: 50px 20px 0;
  p {
    width: 328px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 25px;
  }
  .signImg {
    margin-top: 20px;
    width: 327px;
    height: 83px;
    background: #f2f2f2;
    border-radius: 8px;
    border: 1px solid #ffffff;
  }
}
</style>
